// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"10d06884","453":"801d3fed","766":"4abea81f","817":"56cfde76"}[chunkId] + ".chunk.js";
};